import { createComponent } from '@carvana/vdp-components';
import styled from 'styled-components';
import { stickyBannerZIndex } from '~/constants/vdp/zIndex';
import { breakpoints } from '~/theme';

export const stickyBannerHeightDesktop = 116;

export const Wrapper = styled.div.attrs({
  className:
    'bg-white fixed flex inset-x-0 justify-between max-w-[1800px] mx-auto px-16 py-16 w-full l:px-32'
})`
  height: ${stickyBannerHeightDesktop}px;
  top: ${stickyBannerHeightDesktop * -1}px;

  transition: 0.3s top ease-in-out;
  z-index: ${stickyBannerZIndex};

  @media (min-width: ${breakpoints.m}px) {
    height: ${stickyBannerHeightDesktop}px;
    top: ${stickyBannerHeightDesktop * -1}px;
  }
`;

export const GreyBar = createComponent('div', {
  className: 'border-grey-2 border-l h-full'
});

export const FirstColumn = createComponent('div', {
  className: 'flex flex-col text-blue-6'
});

export const YMM = createComponent('div', {
  className: 'mb-4 mt-8 t-header-s m:t-header-m'
});

export const SmallPrice = createComponent('div', {
  className: 'flex gap-8 items-center t-body-s m:hidden'
});

export const SecondColumn = createComponent('div', {
  className: 'hidden items-center m:flex m:gap-12 l:gap-24'
});

export const MobileShareColumn = createComponent('div', {
  className: 'flex gap-8 items-start justify-center m:hidden'
});

export const BigPrice = createComponent('div', {
  className: 'font-bold leading-[24px] text-[24px] text-blue-6'
});

export const CTAWrapper = createComponent('div', {
  className: 'flex gap-8 items-center m:gap-16'
});
